var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#069",
    d: "M5.504 6.444c0-.518.434-.94.97-.94h11.175c.535 0 .97.422.97.94v11.235c0 .519-.435.94-.97.94H6.474c-.535 0-.97-.421-.97-.94z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.49 16.48v-5.905H7.526v5.904H9.49Zm-.981-6.71c.684 0 1.11-.454 1.11-1.02-.013-.58-.426-1.02-1.097-1.02-.672 0-1.11.44-1.11 1.02 0 .566.425 1.02 1.084 1.02zm2.067 6.71h1.962v-3.298c0-.176.013-.352.064-.478.142-.353.465-.718 1.007-.718.71 0 .994.541.994 1.335v3.158h1.963v-3.385c0-1.813-.968-2.657-2.26-2.657-1.058 0-1.523.591-1.781.994h.013v-.856h-1.962c.025.554 0 5.904 0 5.904Z"
  })));
};
export default SvgLinkedin;